<template>
  <el-select
     ref="select"
     v-model="value"
     class="select-filter"
     :multiple="true"
     :placeholder="placeholder"
     :clearable="true"
     :filterable="true"
     :loading="loader"
     :remote-method="loadSegment"
     :remote="true"
     :disabled="disabled"
     value-key="uniqueName"
     @change="handleChange">
    <el-option
       v-for="v in segment"
       :key="v.uniqueName"
       :label="v.caption"
       :value="v" />
  </el-select>
</template>

<script>
import Filter from './filter.js'
import customGraphApiAware from '../mixins/customGraphApiAware'
import Vue from 'vue'

export default {
  mixins: [Filter, customGraphApiAware],
  data () {
    return {
      loader: false,
      segment: [],
      debounce: null
    }
  },
  watch: {
    values () {
      this.segment.splice(0, this.segment.length, ...this.values.slice(0, 20))
    }
  },
  created () {
    this.updateDefault()
  },
  methods: {
    normalize (str) {
      return str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },
    setValues (values, clearDefault) {
      if (!values) {
        return Promise.resolve()
      }
      this.clearDefault = clearDefault || true
      return this.load().then(() => {
        if (values && values.length) {
          this.segment.splice(0, 0, ...values.filter(
            v => this.segment.findIndex(s => s.uniqueName === v.uniqueName) === -1
          ))
          this.value.splice(0, this.value.length, ...values)
        } else {
          this.value.splice(0)
        }
        this.$emit('change', {
          dimension: this.api.dimension.uniqueName(this.data.value),
          values: values
        })
      })
    },
    handleChange (v) {
      this.$nextTick(() => {
        for (const c of this.$el.children[0].children[0].children) {
          c.children[0].setAttribute('data-title', c.children[0].textContent)
        }
      })
      this.$emit('change', {
        dimension: this.api.dimension.uniqueName(this.data.value),
        values: v
      })
      if (typeof this.$refs.select !== 'undefined') {
        Vue.set(this.$refs.select, 'query', '')
      }
    },
    loadSegment (query) {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        if (query === '') {
          this.segment.splice(0, this.segment.length, ...this.values.slice(0, 20))
        } else {
          this.segment.splice(0, this.segment.length, ...this.values.filter(v => {
            return this.normalize(v.caption).indexOf(this.normalize(query)) > -1
          }).slice(0, 20))
        }
      }, 500)
    }
  }
}
</script>

<style lang="less">
.select-filter {
    .el-input__inner {
        border: none;
        background-color: #eeeef6;
        &::placeholder {
            color: #5a5b5e !important;
            font-weight: bold;
            opacity: 1;
        }
    }
}
.el-select .el-tag {
    background-color: #fff;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
    color: #408C9C;
}
</style>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/filter/SelectFilter.vue